// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

import Rootstore from '../index'
import DataStorageStoreBase from '../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DSSopInstanceElementProps {
  id?: string
  fk_patient_id?: string
  fk_study_folder_id?: string
  fk_study_id?: string
  fk_series_folder_id?: string
  fk_series_id?: string
  sop_instance_uid?: string
  sop_class_uid?: string
  pixel_spacing?: string
  window_center?: string
  window_width?: string
  patient_orientation?: string
  image_orientation_patient?: string
  image_position_patient?: string
  instance_number?: number
  samples_per_pixel?: number
  number_of_frames?: number
  rows?: number
  columns?: number
  pixel_representation?: number
  slice_location?: number
  slice_thickness?: number
  rescale_intercept?: number
  rescale_slope?: number
  temporal_position_identifier?: string
  temporal_position_index?: string
  stack_id?: string
  in_stack_position_number?: string
  path?: string
  created_at?: string
  updated_at?: string
  deleted_at?: string
  fk_volume_disk_id?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageSopInstanceStore extends DataStorageStoreBase<DSSopInstanceElementProps> {
  totalCount: number = 0
  elements: Array<DSSopInstanceElementProps> = []
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({ storeName: 'DS_StudyStore', apiSubUrl: 'dcm/sopinstances', _root: root })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      _setTotalCount: action,
      setElements: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElement = async (id: string) => {
    return await super.get(id)
  }

  getElements = async (path: string) => {
    const rtnData = await super.getAll(path)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as Array<DSSopInstanceElementProps>
  }

  addElement = async (element: DSSopInstanceElementProps) => {
    const newElement = await super.add(element)
    return newElement.id
  }

  removeElement = async (id: string) => {
    return await super.remove(id)
  }

  updateElement = async (id: string, element: DSSopInstanceElementProps) => {
    const updatedElement = await super.update(id, element)
    return updatedElement.id
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<DSSopInstanceElementProps>) => {
    this.elements = elements
  }
}
